import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import CountUp from "react-countup";
import "../styles/projectSuccess.css";

function ProjectSuccess() {
  const cardRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      cardRef.current,
      { opacity: 0, scale: 0.8, y: 50 },
      { opacity: 0.8, scale: 1, y: 0, duration: 2, ease: "back.out" }
    );
  }, []);

  return (
    <div ref={cardRef} className="project-success-container">
      <h3 className="">Project Success</h3>
      <p className="project-success-countUp">
        <CountUp start={0} end={459} duration={2.5} separator="," />+
      </p>
      <p className="project-success-para">
        Our Solar Initiative Project aims to transform communities by providing
        accessible and affordable solar energy solutions.
      </p>
    </div>
  );
}

export default ProjectSuccess;
